export class LeagueWeeklyResult {
    constructor(data, config) {
        var _a, _b, _c;
        Object.defineProperty(this, "resultType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "finalRank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "finalScore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tierAfter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueTiersHeaderSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promotionTiersHeaderSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueTierName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueIconSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.resultType = data.resultType;
        this.finalRank = data.finalRank;
        this.finalScore = data.finalScore;
        this.tierAfter = data.tierAfter;
        this.leagueTiersHeaderSrc = data.leagueTiersHeaderSrc ? config.cdnBaseURL + data.leagueTiersHeaderSrc : '';
        this.promotionTiersHeaderSrc = data.promotionTiersHeaderSrc ? config.cdnBaseURL + data.promotionTiersHeaderSrc : '';
        this.leagueTierName = (_b = (_a = data.leagueAfter) === null || _a === void 0 ? void 0 : _a.leagueTierName) !== null && _b !== void 0 ? _b : '';
        this.leagueIconSrc = ((_c = data.leagueAfter) === null || _c === void 0 ? void 0 : _c.iconSrc) ? config.cdnBaseURL + data.leagueAfter.iconSrc : '';
    }
    get isPromoted() {
        return this.resultType === 'promoted';
    }
    get isMaintained() {
        return this.resultType === 'maintained';
    }
    // 結果種別に応じて上部のシールド帯画像を切り替える
    get tiersHeaderSrc() {
        if (this.isPromoted)
            return this.promotionTiersHeaderSrc || this.leagueTiersHeaderSrc;
        return this.leagueTiersHeaderSrc;
    }
    // finalScore は秒で保持しているため表示用に分へ変換する（切り捨て）
    get finalScoreMinutes() {
        return Math.floor(this.finalScore / 60);
    }
}
